module.exports = require("process");